/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-25 17:07:15
 * @LastEditTime: 2019-10-16 17:51:10
 * @LastEditors: Please set LastEditors
 */
/**
 * wmts常量
 */
export const OLWMTSConstants = {

    crs_4326: "4326",

    crs_3857: "3857",

    /**
     * 切片尺寸
     */
    tileSize: [256, 256],

    /**
     * 经纬度范围 
     */
    geoExtent: [-180.0, -90.0, 180.0, 90.0],

    /**
     * 3857切片方案原点
     */
    epsg3857_origin: [-20037508.342787001, 20037508.342787001],


    /**
     * 3857切片方案分辨率
     */
    epsg3857_resolutions: [
        156543.03392799999,
        78271.516963999893,
        39135.758482000099,
        19567.879240999901,
        9783.9396204999593,
        4891.9698102499797,
        2445.9849051249898,
        1222.9924525624899,
        611.49622628138002,
        305.74811314055802,
        152.874056570411,
        76.437028285073197,
        38.218514142536598,
        19.109257071268299,
        9.5546285356341496,
        4.7773142679493699,
        2.38865713397468,
        1.1943285668550501,
        0.59716428355981699,
        0.29858214164761698
    ],
    /**
     * 3857矩阵集id数组
     */
    epsg3857_matrixIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],

    /**
     * 4326切片方案原点
     */
    epsg4326_origin: [-180, 90],

    /**
     * 天地图4326分辨率
     * 0.7031249999891485开始
     */
    tdt4326_resolutions:
        [
            0.7031249999891485,
            0.35156249999999994,
            0.17578124999999997,
            0.08789062500000014,
            0.04394531250000007,
            0.021972656250000007,
            0.01098632812500002,
            0.00549316406250001,
            0.0027465820312500017,
            0.0013732910156250009,
            0.000686645507812499,
            0.0003433227539062495,
            0.00017166137695312503,
            0.00008583068847656251,
            0.000042915344238281406,
            0.000021457672119140645,
            0.000010728836059570307,
            0.000005364418029785169,
            0.0000026822090148925845,
            0.000001341104532462678
        ],

    /**
     * 天地图4326分辨率
     * 1.406249999978297开始
     */
    tdt4326_resolutionsEx:
        [
            1.406249999978297,
            0.7031249999891485,
            0.35156249999999994,
            0.17578124999999997,
            0.08789062500000014,
            0.04394531250000007,
            0.021972656250000007,
            0.01098632812500002,
            0.00549316406250001,
            0.0027465820312500017,
            0.0013732910156250009,
            0.000686645507812499,
            0.0003433227539062495,
            0.00017166137695312503,
            0.00008583068847656251,
            0.000042915344238281406,
            0.000021457672119140645,
            0.000010728836059570307,
            0.000005364418029785169,
            0.0000026822090148925845,
            0.000001341104532462678
        ],

    /**
     * 天地图4326切片方案矩阵集ids
     */
    tdt4326_matrixIds: [1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20],


}